document.addEventListener("turbo:before-frame-render", (event) => {
  const scrollContainers = document.querySelectorAll(".scroll-container");

  scrollContainers.forEach((scrollContainer) => {
    if (!scrollContainer.id) {
      console.warn('`.scroll-container` must have an id attribute');
      return;
    }

    // Set scrollX to "false" to skip scrolling horizontally
    // Set scrollY to "false" to skip scrolling vertically
    // When none set, scrolls both horizontally and vertically
    const scrollX = scrollContainer.dataset.scrollX;
    const scrollY = scrollContainer.dataset.scrollY;

    if (scrollY !== "false") sessionStorage.setItem(`${scrollContainer.id}-scrollTop`, scrollContainer.scrollTop);
    if (scrollX !== "false") sessionStorage.setItem(`${scrollContainer.id}-scrollLeft`, scrollContainer.scrollLeft);
  });
});

document.addEventListener("turbo:frame-load", (event) => {
  const scrollContainers = document.querySelectorAll(".scroll-container");

  scrollContainers.forEach((scrollContainer) => {
    if (!scrollContainer.id) {
      console.warn('`.scroll-container` must have an id attribute');
      return;
    }

    const scrollTop  = sessionStorage.getItem(`${scrollContainer.id}-scrollTop`);
    const scrollLeft = sessionStorage.getItem(`${scrollContainer.id}-scrollLeft`);

    scrollContainer.scrollTo({
      top: scrollTop || scrollContainer.scrollTop,
      left: scrollLeft || scrollContainer.scrollLeft,
      behavior: "instant"
    });
  });
});
